import { Breadcrumb, BreadcrumbItem } from "@chakra-ui/react";
import { useMemo } from "react";
import { Params, useMatches } from "react-router-dom";

interface IMatches {
  id: string;
  pathname: string;
  params: Params<string>;
  data: unknown;
  handle: unknown;
}

type HandleType = {
  crumb: (param?: string) => React.ReactNode;
};

export default function Breadcrumbs() {
  const matches: IMatches[] = useMatches();
  const crumbs = useMemo(
    () =>
      matches
        .filter((match) =>
          Boolean(match.handle && (match.handle as HandleType).crumb),
        )
        .map((match) => {
          const crumb = (match.handle as HandleType).crumb(
            match.data as string | undefined,
          );
          return crumb as React.ReactNode;
        }),
    [matches],
  );

  return (
    <Breadcrumb>
      {crumbs.map((crumb, index) => (
        <BreadcrumbItem key={index}>{crumb}</BreadcrumbItem>
      ))}
    </Breadcrumb>
  );
}
